import type { ExperienceListFilters } from 'actions/ExperienceActions'
import { EmptyArray } from 'lib/array/arrayUtils'
import buildLoyaltyLoungePassFilters from 'lib/experiences/buildLoyaltyLoungePassFilters'
import getFlightDetailsByOrderItems from 'lib/flights/getFlightDetailsByOrderItems'
import { createSelector } from 'reselect'
import { isSpoofed } from 'selectors/isSpoofed'
import { getClosestAirport } from 'selectors/flightsSelectors'
import { getViewedOrder } from 'selectors/orderSelectors'

const getLoyaltyOrderViewLoungePassFilters = createSelector(
  (state: App.State) => getViewedOrder(state),
  (state: App.State) => state.geo.airports,
  (state: App.State) => state.offer.offers,
  (state: App.State) => getClosestAirport(state),
  (state: App.State) => state.orders.flightDetails,
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => state.auth.account.recentlyUsedAirportCode,
  (state: App.State) => state.experience.experiences,
  (state: App.State) => state.experience.experienceLists,
  (state: App.State) => isSpoofed(state),
  (state: App.State) => state.cruise.cruiseOfferSnapshot,
  (existingOrder, airports, offers, closestAirport, flightDetails, regionCode, recentlyUsedAirportCode, experiences, experienceLists, isSpoofed, cruiseOfferSnapshots): Array<ExperienceListFilters> => {
    if (!existingOrder) return EmptyArray

    const flightDetailsByOrderItems = getFlightDetailsByOrderItems(existingOrder, flightDetails)

    const filters = buildLoyaltyLoungePassFilters({
      bedbankItems: existingOrder.bedbankItems,
      tourItems: existingOrder.tourItems,
      hotelItems: existingOrder.items,
      flightItems: existingOrder.flightItems,
      cruiseItems: existingOrder.cruiseItems,
      cruiseOfferSnapshots,
      experiences,
      experienceLists,
      airports,
      regionCode,
      isSpoofed,
      flightDetailsByOrderItems,
      offers,
      closestAirport,
      recentlyUsedAirportCode,
    })

    return filters
  },
)

export default getLoyaltyOrderViewLoungePassFilters
